import React from "react";
import useDeviceDetection from "./hooks/useDeviceDetection";
import Header from "./Header";
import HeaderMobile from "./mobile/HeaderMobile";

export default function HeaderWrapper(props) {
  const device = useDeviceDetection();

  return (
    <div>
      {device.isMobile ? <HeaderMobile {...props} /> : <Header {...props} />}
    </div>
  );
}
